var _style, _g, _polygon, _path, _path2, _path3, _rect, _path4, _path5, _polygon2, _polygon3, _path6, _circle, _circle2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnDiscover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    width: 42,
    height: 24,
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#F48120;}\r\n\t.st2{fill:#231F20;}\r\n\t.st3{fill:url(#XMLID_3_);}\r\n\t.st4{opacity:0.65;fill:url(#XMLID_4_);enable-background:new    ;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_432_"
  })), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_428_",
    className: "st0",
    points: "1.75,94.2 510.11,94.2 510.11,417.84 1.89,417.84  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_427_",
    className: "st1",
    d: "M508.36,274.21c0,0-138.91,97.95-393.3,141.88h393.3V274.21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st2",
    d: "M510.11,92.31H0v327.41h512V92.18h-1.89V92.31z M508.36,95.95c0,3.64,0,316.36,0,320 c-3.64,0-500.95,0-504.59,0c0-3.64,0-316.36,0-320C7.41,95.95,504.59,95.95,508.36,95.95z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.73,192.42H23.58v74.11h21.15c11.18,0,19.27-2.69,26.41-8.49c8.49-7.01,13.47-17.52,13.47-28.43 C84.48,207.65,68.18,192.42,44.73,192.42z M61.71,248.2c-4.58,4.04-10.37,5.93-19.81,5.93H38v-49.04h3.91 c9.3,0,14.96,1.62,19.81,5.93c4.99,4.45,7.95,11.32,7.95,18.46C69.66,236.62,66.69,243.76,61.71,248.2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_422_",
    x: 91.22,
    y: 192.42,
    className: "st2",
    width: 14.42,
    height: 74.11
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_421_",
    className: "st2",
    d: "M140.93,220.85c-8.62-3.23-11.18-5.39-11.18-9.3c0-4.72,4.58-8.22,10.78-8.22 c4.31,0,7.95,1.75,11.59,6.06l7.55-9.84c-6.2-5.39-13.61-8.22-21.83-8.22c-13.07,0-23.17,9.16-23.17,21.29 c0,10.24,4.72,15.49,18.19,20.35c5.66,2.02,8.49,3.37,9.97,4.18c2.83,1.89,4.31,4.58,4.31,7.68c0,6.06-4.72,10.51-11.18,10.51 c-6.87,0-12.4-3.5-15.76-9.84l-9.3,9.03c6.6,9.84,14.69,14.15,25.6,14.15c14.96,0,25.6-9.97,25.6-24.39 C162.36,232.3,157.37,226.91,140.93,220.85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_420_",
    className: "st2",
    d: "M166.8,229.61c0,21.83,17.11,38.67,39.07,38.67c6.2,0,11.59-1.21,18.05-4.31v-16.98 c-5.79,5.79-10.91,8.08-17.38,8.08c-14.55,0-24.93-10.51-24.93-25.6c0-14.28,10.64-25.47,24.25-25.47c6.87,0,12.13,2.43,18.05,8.35 v-16.98c-6.33-3.23-11.59-4.58-17.79-4.58C184.45,190.8,166.8,208.05,166.8,229.61z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_419_",
    className: "st2",
    points: "338.73,242.27 318.92,192.42 303.16,192.42 334.55,268.41 342.37,268.41 374.3,192.42 358.67,192.42  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_418_",
    className: "st2",
    points: "380.9,266.53 421.86,266.53 421.86,254 395.32,254 395.32,234.06 420.92,234.06 420.92,221.52 395.32,221.52 395.32,205.09 421.86,205.09 421.86,192.42 380.9,192.42  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M479.12,214.38c0-13.88-9.57-21.83-26.27-21.83h-21.42v74.11h14.42v-29.78h1.89l19.94,29.78h17.79 l-23.31-31.26C473.06,233.11,479.12,225.7,479.12,214.38z M450.02,226.64h-4.18v-22.5h4.45c9.03,0,13.88,3.77,13.88,11.05 C464.17,222.6,459.32,226.64,450.02,226.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.4383,
    y1: 841.3354,
    x2: 261.1489,
    y2: 798.608,
    gradientTransform: "matrix(1 0 0 1 0 -580)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F89F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2502,
    style: {
      stopColor: "#F79A20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5331,
    style: {
      stopColor: "#F68D20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6196,
    style: {
      stopColor: "#F58720"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    style: {
      stopColor: "#F48120"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37521"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_415_",
    className: "st3",
    cx: 268.26,
    cy: 229.74,
    r: 39.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.1299,
    y1: 840.7604,
    x2: 244.2456,
    y2: 762.804,
    gradientTransform: "matrix(1 0 0 1 0 -580)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F58720"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3587,
    style: {
      stopColor: "#E16F27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    style: {
      stopColor: "#D4602C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    style: {
      stopColor: "#D05B2E"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_414_",
    className: "st4",
    cx: 268.26,
    cy: 229.74,
    r: 39.48
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_436_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M488.29,195.25c0-1.35-0.94-2.02-2.43-2.02h-2.16v6.47h1.62v-2.56l1.89,2.56h1.89l-2.16-2.69 C487.75,196.87,488.29,196.19,488.29,195.25z M485.59,196.19h-0.27v-1.75h0.27c0.81,0,1.21,0.27,1.21,0.81 C486.8,195.92,486.4,196.19,485.59,196.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M486.13,190.8c-3.1,0-5.66,2.56-5.66,5.66s2.56,5.66,5.66,5.66c3.1,0,5.66-2.56,5.66-5.66 S489.23,190.8,486.13,190.8z M486.13,201.18c-2.43,0-4.58-2.02-4.58-4.72c0-2.56,2.02-4.72,4.58-4.72c2.43,0,4.45,2.16,4.45,4.72 C490.58,199.02,488.56,201.18,486.13,201.18z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDiscover);
export default __webpack_public_path__ + "static/media/icn-discover.3ebc99e6.svg";
export { ForwardRef as ReactComponent };